import { Flex, Text, Avatar as ChakraAvatar, Box } from '@chakra-ui/react';
import React, { useState } from 'react';
import { Heading } from '~/components';
import { useSinisterLog } from '~/hooks/useSinisters/useSinisters';

export const RecentActivity: React.FC<{ sinisterId: number }> = ({
  sinisterId,
}) => {
  const [isFetching, setFetching] = useState(false);
  const { data, isLoading } = useSinisterLog(Number(sinisterId));

  return (
    <>
      <Box px="8" py="4" padding={0}>
        <Heading fontSize={16}> Atividades recentes</Heading>
        {data && data.length ? (
          data.map(log => (
            <Flex align="center" gridGap="2" marginTop={5} key={log.id}>
              <ChakraAvatar size="md" name={log.nome_usuario} />
              <Text>
                <Text fontSize={{ lg: 'md', md: 'md' }}>{log.descricao}</Text>
                <Text fontSize={{ lg: 'sm', md: 'sm' }}>
                  {log.formattedDate}
                </Text>
              </Text>
            </Flex>
          ))
        ) : (
          <Text marginTop={4}>Não há atividades recentes.</Text>
        )}
      </Box>
    </>
  );
};
